import React, { forwardRef, useRef, useImperativeHandle, useMemo } from 'react';

import AceEditor from 'react-ace';
import 'ace-builds/src-noconflict/ace';
import 'ace-builds/src-noconflict/mode-sql';
import 'ace-builds/src-noconflict/theme-sqlserver';
import 'ace-builds/src-noconflict/theme-dracula';
import 'ace-builds/src-noconflict/ext-language_tools';
import 'ace-builds/src-noconflict/ext-searchbox';

import {getEditorOptions, getEditorProps, getNowTS} from './utils';

interface SqlEditorProps {
  defaultValue: string;
  contentId: number | string;
  onLoad: (editor: any) => void;
  onChange: (value: string) => void;
  disabled?: boolean;
}

const SqlEditorComponent = forwardRef(({
  defaultValue,
  contentId,
  onLoad,
  onChange,
  disabled = false,
}: SqlEditorProps, ref: any) => {
  const aceEditorRef = useRef<any>();
  const name = useMemo(() => 'code_editor_' + contentId, []);

  const editorOptions = useMemo(() => getEditorOptions(disabled), [disabled]);
  const editorProps = useMemo(() => getEditorProps(), []);

  useImperativeHandle(ref, () => ({
    getEditor() {
      return aceEditorRef.current.editor;
    }
  }));

  return (
    <AceEditor
      ref={aceEditorRef}
      onLoad={onLoad}
      className={'sql-editor' + (disabled ? ' readonly' : '')}
      editorProps={editorProps}
      setOptions={editorOptions}
      height="100%"
      width="100%"
      mode="sql"
      theme="sqlserver"
      name={name}
      defaultValue={defaultValue}
      onChange={onChange}
    />
  );
});

export const SqlEditor = React.memo(SqlEditorComponent);
export default SqlEditor;
